export enum RecurrenceType {
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly',
}
